import axios from "axios";

const fetchData = async (smile) => {
  const host = "https://l7uzf23bl0.execute-api.us-east-1.amazonaws.com/api";

  const headers = {
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Credentials": true,
    "Content-Type": "application/json",
  };

  try {
    const res = await axios.post(host, smile, headers);
    //console.log(res["data"]);
    return res["data"];
  } catch (e) {
    console.log(e);
    return e;
  }
};

export default fetchData;
